import "../../styles/Alert.css";

interface AlertProps {
  message: string;
  type?: "success" | "error" | "warning";
  onClose: () => void;
}


const Alert = ({ message, type = "success", onClose }: AlertProps) => {
  if (!message) return null;

  return (
    <div className={`alert alert-${type}`}>
      <span>{message}</span>
      <button onClick={onClose}>X</button>
    </div>
  );
};


export default Alert;
